







































import { Component } from 'nuxt-property-decorator'
import { ModalComponentBaseVue } from '@/base'
import ModalFooter from '@/components/molecules/ModalFooter/ModalFooter.vue'
import { authUserStore } from '@/utils/store-accessor'
import { VERSION } from '@/version'

@Component({
  components: {
    ModalFooter
  }
})
export default class ModalVersionInfo extends ModalComponentBaseVue {
  dialog: boolean = false

  open(): void {
    this.dialog = true
  }

  close(): void {
    this.dialog = false
  }

  get frontVersion(): string {
    return `v${VERSION}`
  }

  get apiVersion(): string {
    return authUserStore.authUser.apiVersion
  }

  onClickOk(): void {
    this.close()
  }

  onClickPrint(): void {
    const element = document.querySelector<HTMLElement>(
      '.v-dialog--active #modal-version-info'
    )
    if (element) {
      this.$webSocket.sendDialogScreenshotMessage(element)
    } else {
      this.$webSocket.sendScreenshotMessage()
    }
  }
}
